/*  inline demuxer.
 *   probe fragments and instantiate appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
 */

import Event from './hlsjs/events';
//import {ErrorTypes, ErrorDetails} from '../errors';
import MactrixDecrypter from './aes/MactrixDecrypter';
import ArrayHelper from './helpers/ArrayHelper';
import muxjs from './muxjs';
import Utils from './HlsUtils';
import Lodash from 'lodash';

class Fragment {
	constructor() {
		this.segments = [];
		this.length = 0;
	}
}

class MuxJsInline {
	constructor(observer, typeSupported, config, vendor, logTube) {
		this.observer = observer;
		this.vendor = vendor;
		this.typeSupported = typeSupported;
		this.config = config;
		this.videoFragment = new Fragment();
		this.audioFragment = new Fragment();
		this.combinedFragment = new Fragment();
		this.initPts = -1;
		this.remux = false;
		this.resetInitSegment = true;
		this.transmuxer = null;
		this.enableAudio = true;
		this.enableVideo = true;
		this.logTube = logTube;
		this.timeInfoList = [];
		this.pdt = 0;
	}

	destroy() {
		this.transmuxer = null;
		this.videoFragment = null;
		this.audioFragment = null;
		this.combinedFragment = null;
	}

	push(
		data,
		decryptdata,
		initSegment,
		audioCodec,
		videoCodec,
		timeOffset,
		discontinuity,
		trackSwitch,
		seek,
		duration,
		accurateTimeOffset,
		lastFragAborted,
		pdt) {

		if ((data.byteLength > 0) && (decryptdata != null) && (decryptdata.key != null) && (decryptdata.method === 'AES-128')) {
			let decrypter = this.decrypter;
			if (decrypter == null) {
				decrypter = this.decrypter = new MactrixDecrypter(this.observer, this.config);
			}
			var localthis = this;
			// performance.now() not available on WebWorker, at least on Safari Desktop
			var startTime;
			try {
				startTime = performance.now();
			}
			catch(error) {
				startTime = Date.now();
			}
			decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
				var endTime;
				try {
					endTime = performance.now();
				}
				catch(error) {
					endTime = Date.now();
				}
				localthis.observer.trigger(Event.FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
				localthis.pushDecrypted(
					ArrayHelper.makeUint8Array(decryptedData),
					decryptdata,
					new Uint8Array(initSegment),
					audioCodec,
					videoCodec,
					timeOffset,
					discontinuity,
					trackSwitch,
					seek,
					duration,
					accurateTimeOffset,
					lastFragAborted,
					pdt);
			});
		}
		else {
			this.pushDecrypted(
				ArrayHelper.makeUint8Array(data),
				decryptdata, new Uint8Array([]),
				audioCodec,
				videoCodec,
				timeOffset,
				discontinuity,
				trackSwitch,
				seek,
				duration,
				accurateTimeOffset,
				lastFragAborted,
				pdt);
		}
	}

	pushDecrypted(
		data,
		decryptdata,
		initSegment,
		audioCodec,
		videoCodec,
		timeOffset,
		discontinuity,
		trackSwitch,
		seek,
		duration,
		gap,
		lastFragAborted,
		pdt
		) {
		var transmuxer = this.transmuxer;

	// in case of continuity change, we might switch from content type (AAC container to TS container for example)
	// so let's check that current demuxer is still valid
		if (!transmuxer) {
			let localthis = this;

			transmuxer = new muxjs.mp4.Transmuxer({ remux: this.remux, duration: duration, baseMediaDecodeTime: timeOffset * 90000,
				allowNegativeTFDT: !this.typeSupported.browChrome && !Utils.isTizen3(), logTube: this.logTube });

			transmuxer.on('data', function (event) {
				localthis.onData(event);
			});

			transmuxer.on('done', function () {
				localthis.onDone(this.baseMediaDecodeTime);
			});

			this.transmuxer = transmuxer;
		}

		//ignore gaps on seeks
		if(!seek) {
			//if we have have a gap in the stream, in the case of audio we will fill it with silence (not implemented) or extend the first video frame
			transmuxer.setGapDuration(gap);
		}

/*
		if(lastFragAborted === true) {
			console.log('# pushDecrypted lastFragAborted: ' + lastFragAborted);
			transmuxer.setLastFragAborted(lastFragAborted);
		}
*/

/*
		if (seek && gap) {
			console.log('# ignore gap on seek: ' + seek + ' : ' + gap);
		}
*/

		if (trackSwitch || discontinuity || seek) {
			this.resetInitSegment = true;

			//don't reset the time on disco ... this will most likely break metadata and closed captioning across the disco
			//solution is most likely to split setBaseMediaDecodeTime into two functions, one for seek the other for disco
			if (/*discontinuity ||*/ seek) {
				let bmdt = timeOffset * 90000;

				let searchPdt = function (candidate) {
					let found;

					if(pdt >= candidate.pdt - candidate.variance && pdt <= candidate.pdt + candidate.variance) {
						found = true;
					}
					else {
						found = false;
					}

					return found;
				};

				let timeInfo = Lodash.find(this.timeInfoList, searchPdt);

				if(timeInfo) {
					bmdt = timeInfo.bmdt;
				}
				//else {
				// the pdt is not in the current list, this means we have seeked or flushed.
				//}

				transmuxer.setBaseMediaDecodeTime(bmdt);

				this.timeInfoList = [];
			}
		}

		this.pdt = pdt;

		transmuxer.push(data);
		transmuxer.flush();
	}

	onData(event) {
		if(event.type === 'video' && this.enableVideo === true) {
			this.videoFragment.segments.push(event);
			this.videoFragment.length += event.data.length;
		}
		else if(event.type === 'audio' && this.enableAudio === true) {
			this.audioFragment.segments.push(event);
			this.audioFragment.length += event.data.length;
		}
		else if(event.type === 'combined') {
			this.combinedFragment.segments.push(event);
			this.combinedFragment.length += event.data.length;
		}
	}

	doInitSegment() {
		let tracks = {};
		let data = { tracks: tracks };

		if(this.combinedFragment.length > 0 && !this.combinedFragment.segments[0].duplicate) {
			//if(this.combinedFragment.segments[0].length > 1) {
			//	console.warn('combined fragment contains more than one segment');
			//}

			tracks.video = {
				container: 'video/mp4', //videoCodec?
				codec: 'avc1.42e00b', //need to form the codec from the event info
				initSegment: this.combinedFragment.segments[0].initSegment,
				metadata: {
					width: this.combinedFragment.segments[0].info.width,
					height: this.combinedFragment.segments[0].info.height,
				},
			};

			tracks.audio = {
				container: 'audio/mp4', //audioCodec?
				codec: 'mp4a.40.2', //need to form the codec from the event info
				initSegment : null,
				//remuxedSegments[i].initSegment,//!audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : MP4.initSegment([audioTrack]),
				metadata: {
					channelCount : this.combinedFragment.segments[0].audioInfo.channelcount,
				},
			};

			this.resetInitSegment = false;
		}
		else {
			if(this.videoFragment.length > 0 && !this.videoFragment.segments[0].duplicate) {
				//if(this.videoFragment.segments[0].length > 1) {
				//	console.warn('video fragment contains more than one segment');
				//}

				tracks.video = {
					container: 'video/mp4', //videoCodec?
					codec: 'avc1.42e00b', //need to form the codec from the event info
					initSegment: this.videoFragment.segments[0].initSegment,
					metadata: {
						width: this.videoFragment.segments[0].info.width,
						height: this.videoFragment.segments[0].info.height,
					},
				};

				this.resetInitSegment = false;
			}

			if(this.audioFragment.length > 0 && !this.audioFragment.segments[0].duplicate) {
				//if(this.audioFragment.segments[0].length > 1) {
				//	console.warn('audio fragment contains more than one segment');
				//}

				tracks.audio = {
					container: 'audio/mp4', //audioCodec?
					codec: 'mp4a.40.2', //need to form the codec from the event info
					initSegment: this.audioFragment.segments[0].initSegment,
					//!audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : MP4.initSegment([audioTrack]),
					metadata: {
						channelCount: this.audioFragment.segments[0].info.channelcount,
					},
				};

				this.resetInitSegment = false;
			}
		}

		if(tracks.audio || tracks.video) {
			this.observer.trigger(Event.FRAG_PARSING_INIT_SEGMENT, data);
		}
	}

	doFrag(fragment) {
		//stash the correct base media decode time for this fragment, allow a pdt variance of 1/2 a fragment duration.
		this.timeInfoList.push({ pdt: this.pdt, variance: (fragment.info.fragmentDuration * 500), bmdt: fragment.info.startTime });

		let startTime = fragment.info.startTime / 90e3;
		let endTime = startTime + fragment.info.fragmentDuration;
		let data = {
			data1: fragment.data,
			data2: null, //is ignored
			startPTS: startTime,
			endPTS: endTime,
			startDTS: startTime,
			endDTS: endTime,
			type: fragment.type,
			nb: fragment.info.totalSamples,
			dropped: 0, //dropped
			duplicate: fragment.duplicate,
			dts: fragment.timeStamp,
		};

		this.observer.trigger(Event.FRAG_PARSING_DATA, data);
	}

	doMetadata(metadata) {
		if(metadata.length > 0) {
			//match exactly what hlsjs is throwing out
			let samples = [];

			for(let index = 0; index < metadata.length; index++) {
				let sample = { data: null, pts: 0, dts: 0, len: 0 };
				sample.data = metadata[index].data;
				sample.pts = metadata[index].pts;
				sample.dts = metadata[index].dts;
				sample.len = metadata[index].data.length;
				samples.push(sample);
			}

			this.observer.trigger(Event.FRAG_PARSING_METADATA, {
				samples: samples,
			});
		}
	}

	doCaptions(captions) {
		if(captions.length > 0) {
			this.observer.trigger(Event.FRAG_PARSING_USERDATA, {
				samples: captions,
			});
		}
	}

	deliverFragment(fragment) {
		this.doFrag(fragment.segments[0]);
		this.doMetadata(fragment.segments[0].metadata);
		this.doCaptions(fragment.segments[0].captions);

		fragment.segments = [];
		fragment.length = 0;
	}

	onDone(baseMediaDecodeTime) {
		if( this.initPts !== baseMediaDecodeTime) {
			this.observer.trigger(Event.INIT_PTS_FOUND, { initPTS: baseMediaDecodeTime });
			this.initPts = baseMediaDecodeTime;
		}

		//send out the init segment
		if(this.resetInitSegment === true ) {
			this.doInitSegment();
		}

		//send out the rest of the frag
		if(this.combinedFragment.length > 0) {
			this.deliverFragment(this.combinedFragment);
		}
		else {
			if(this.videoFragment.length > 0) {
				this.deliverFragment(this.videoFragment);
			}

			if(this.audioFragment.length > 0) {
				this.deliverFragment(this.audioFragment);
			}
		}

		this.observer.trigger(Event.FRAG_PARSED);
	}
}

export default MuxJsInline;



// WEBPACK FOOTER //
// ./src/muxjs-inline.js